// extracted by mini-css-extract-plugin
module.exports = {"chatLink":"Markdown_chatLink__XjWvP","extIcon":"Markdown_extIcon__c7oXe"};